import React from 'react';
var Row = function (props) {
    var align = props.align, className = props.className, children = props.children;
    var classes = ['row'];
    if (align !== undefined)
        classes.push("align-items-" + align);
    if (className !== undefined)
        classes.push(className);
    return React.createElement("div", { className: classes.join(' ') }, children);
};
export default Row;
